import React from 'react';
import { Center } from '@fiverr-private/layout_components';

export const ImportImage = () => (
    <Center width={151} height={99}>
        <svg
            viewBox="0 0 151 99"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Import from linkedIn image"
        >
            <rect
                x="4.01931"
                y="30.1875"
                width="41.5"
                height="41.5"
                rx="3.75"
                transform="rotate(4.02331 4.01931 30.1875)"
                fill="white"
            />
            <rect
                x="4.01931"
                y="30.1875"
                width="41.5"
                height="41.5"
                rx="3.75"
                transform="rotate(4.02331 4.01931 30.1875)"
                stroke="#222325"
                strokeWidth="1.5"
            />
            <g clipPath="url(#clip0_3796_101671)">
                <rect
                    width="22.8571"
                    height="22.8571"
                    transform="translate(12.6641 40.1401) rotate(4.02331)"
                    fill="white"
                />
                <path
                    d="M34.503 41.6762L13.626 40.2078C13.0916 40.1702 12.634 40.5677 12.5964 41.102L11.1255 62.0147C11.0904 62.5134 11.4879 62.971 12.0223 63.0086L32.9349 64.4795C33.4693 64.5171 33.9269 64.1197 33.9644 63.5853L35.4328 42.7083C35.4348 42.1714 35.0374 41.7138 34.503 41.6762ZM18.0674 60.0326L14.6829 59.7945L15.4472 48.9285L18.8317 49.1665L18.0674 60.0326ZM17.2268 47.55C16.1581 47.4748 15.33 46.5215 15.4052 45.4527C15.4804 44.3839 16.4337 43.5559 17.5025 43.6311C18.5713 43.7062 19.3993 44.6595 19.3241 45.7283C19.2464 46.8328 18.3313 47.6276 17.2268 47.55ZM30.7147 60.9221L27.3302 60.6841L27.7011 55.4114C27.7888 54.1645 27.8684 52.5231 26.1584 52.4029C24.4127 52.2801 24.0299 53.6495 23.9322 55.0389L23.5538 60.4185L20.1693 60.1804L20.9336 49.3144L24.1756 49.5424L24.0704 51.0387L24.106 51.0412C24.6293 50.2188 25.7963 49.4058 27.4351 49.5211C30.8553 49.7616 31.3387 52.0512 31.1332 54.9725L30.7147 60.9221Z"
                    fill="#222325"
                />
            </g>
            <path
                d="M57.3884 52.9764C57.3884 52.9764 66.839 47.5842 77.1953 46.7042C87.1798 45.8591 95.8782 48.2959 95.8782 48.2959L88.6663 38.5781"
                stroke="#222325"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M87.1064 56.8636L95.8828 48.2989" stroke="#222325" strokeWidth="1.5" strokeLinejoin="round" />
            <path
                d="M113.647 24H150.091L147.176 74.6851H110.731L113.647 24Z"
                stroke="#0E0E0F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path d="M126.254 33.0674H142.558" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M126.254 36.8525H137.224" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M125.84 46.5513H142.144" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M125.84 50.3369H136.81" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M125.426 60.4004H141.315" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path d="M125.426 64.1807H136.396" stroke="#0E0E0F" strokeWidth="1.5" strokeMiterlimit="10" />
            <path
                d="M122.854 37.4978H118.39L118.51 33.0674H122.974L122.854 37.4978Z"
                stroke="#0E0E0F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M122.44 50.9817H117.976L118.096 46.5513H122.56L122.44 50.9817Z"
                stroke="#0E0E0F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M122.026 64.8308H117.562L117.682 60.4004H122.146L122.026 64.8308Z"
                stroke="#0E0E0F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <defs>
                <clipPath id="clip0_3796_101671">
                    <rect
                        width="22.8571"
                        height="22.8571"
                        fill="white"
                        transform="translate(12.6641 40.1401) rotate(4.02331)"
                    />
                </clipPath>
            </defs>
        </svg>
    </Center>
);
